import { Wallet } from "lucide-react";

interface Props {
  balance: number;
}

const CashBalanceBadge = ({ balance }: Props) => {

  let bgColor = "bg-[#3CA745]"; // success
  let textColor = "text-white";

  if (balance <= 0) {
    bgColor = "bg-[#DC3545]"; // danger
  } else if (balance < 20) {
    bgColor = "bg-[#F9C107]"; // warning
    textColor = "text-[#212B36]";
  }

  return (
    <div className={`inline-flex items-center gap-2 rounded py-1 px-3 text-sm font-medium ${bgColor} ${textColor}`}>
      <Wallet size={14} />
      ${balance.toFixed(2)}
    </div>
  );
};

export default CashBalanceBadge;